import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RecopsChecklist from "@/pages/RecopsChecklist";

export const Route = createFileRoute("/es/checklist-registro-medical-devices-recops-aemps")({
  head: () => buildRouteHead("/es/checklist-registro-medical-devices-recops-aemps"),
  component: RecopsChecklist,
});

